import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { hasAdminCode, clearAdminCode, isLockedPath } from "@/components/AdminCodeGate";

// «Blocca»: richiude subito le pagine riservate. Inoltre, appena si esce da una pagina
// riservata verso una normale, il codice viene dimenticato (va rimesso al prossimo ingresso).
export function LockButton({ className = "", testId = "lock-btn" }) {
  const [unlocked, setUnlocked] = useState(hasAdminCode());
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const sync = () => setUnlocked(hasAdminCode());
    window.addEventListener("admin-code-changed", sync);
    window.addEventListener("admin-code-required", sync);
    return () => { window.removeEventListener("admin-code-changed", sync); window.removeEventListener("admin-code-required", sync); };
  }, []);

  useEffect(() => {
    if (!isLockedPath(location.pathname) && hasAdminCode()) clearAdminCode();
  }, [location.pathname]);

  if (!unlocked) return null;
  const lock = () => {
    clearAdminCode();
    toast.success("Pagine riservate bloccate");
    if (isLockedPath(location.pathname)) navigate("/admin/home");
  };
  return (
    <Button variant="outline" size="sm" onClick={lock} data-testid={testId} className={`w-full h-11 rounded-xl border-[#1F1F1F] ${className}`}>
      <Lock className="w-4 h-4 mr-2" /> Blocca riservate
    </Button>
  );
}
